import { useCallback } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from 'nhsuk-react-components';
import { SummaryReport } from '../../schemas/SummaryReport.schema';

interface SummaryReportsLinkProps {
  summaryReports?: SummaryReport[];
  renderAs?: 'link' | 'button';
}

function SummaryReportsLink({ renderAs = 'link', summaryReports = [] }: SummaryReportsLinkProps) {
  const navigate = useNavigate();
  const reportButtonText = 'View summary reports';

  const onClick = useCallback(() => {
    navigate('reports', { state: summaryReports });
  }, [navigate, summaryReports]);

  if (renderAs === 'button') {
    return (
      <Button
        onClick={onClick}
        aria-label={reportButtonText}
        data-testid="view-summary-reports"
      >
        {reportButtonText}
      </Button>
    );
  }

  return (
    <Link to="reports" state={summaryReports} aria-label="View summary reports" data-testid="view-summary-reports">
      {reportButtonText}
    </Link>
  );
}

export default SummaryReportsLink;
